import React, { useState } from "react";

const AppointmentForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    city: "",
    service: "",
    date: "",
    time: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Send request to backend here
    console.log("Appointment request submitted:", formData);
    alert("Your appointment request has been sent successfully!");
  };

  return (
    <section className="py-16  text-dark">
      <div className="max-w-4xl mx-auto px-6 bg-white shadow-lg rounded-xl p-8 border-t-4 border-primary">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 text-center">
          Schedule Your Appointment
        </h2>
        <p className="text-secondary text-center mb-8">
          Book logistics and relocation services with ease. Select your service, fill your details, and we'll get back to you with quotes.
        </p>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Full Name"
            required
            className="p-3 border border-gray-300 rounded"
          />
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone Number"
            required
            className="p-3 border border-gray-300 rounded"
          />
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="City"
            required
            className="p-3 border border-gray-300 rounded"
          />
          <select
            name="service"
            value={formData.service}
            onChange={handleChange}
            required
            className="p-3 border border-gray-300 rounded"
          >
            <option value="">-- Select Service --</option>
            <option value="home-relocation">Home Relocation</option>
            <option value="vehicle-transport">Vehicle Transport</option>
            <option value="office-shifting">Office Shifting</option>
            <option value="warehouse-services">Warehouse Services</option>
          </select>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
            className="p-3 border border-gray-300 rounded"
          />
          <input
            type="time"
            name="time"
            value={formData.time}
            onChange={handleChange}
            required
            className="p-3 border border-gray-300 rounded"
          />

          <div className="md:col-span-2 flex flex-col md:flex-row gap-4 mt-4 justify-center">
            <button
              type="button"
              className="bg-secondary hover:bg-accent text-white font-medium px-6 py-3 rounded w-full md:w-1/2 transition"
              onClick={() => alert("Get Quotes feature coming soon!")}
            >
              Get Quotes
            </button>
            <button
              type="submit"
              className="bg-primary hover:bg-dark text-white font-medium px-6 py-3 rounded w-full md:w-1/2 transition"
            >
              Send Request
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default AppointmentForm;
